import { render } from "./XbankPage.vue?vue&type=template&id=461bb3c0"
import script from "./XbankPage.vue?vue&type=script&lang=js"
export * from "./XbankPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__